import { Component, ViewChild } from '@angular/core';
import { Toast, ToastrService } from 'ngx-toastr';
import { ExcelService } from 'src/app/services/excel-service.service';
import { CompetenciesService } from '../competencies.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-mentors-dashboard',
  templateUrl: './mentors-dashboard.component.html',
  styleUrls: ['./mentors-dashboard.component.css']
})
export class MentorsDashboardComponent {

  searchQuery: string = '';

  totalMentorsList: any = [];
  
  mentorsList = [];
  
  filteredMentorsList = [];

  displayedColumns = [
    'employeeId',
    'mentor',
    'mentorMail',
    'mentee',
    'timeSpent',
    'trainings',
  ];

  from = 0;

  size = 10;

  isMentorListLoading = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private excelService: ExcelService,
    private toaster: ToastrService,
    private competenciesService: CompetenciesService,
  ) { }

  ngOnInit() {
    this.isMentorListLoading = true;
    const mandotoryKeys = ['trainingsAssigned', 'menteeName', 'mentorName', 'mentorEmployeeID'];
    this.competenciesService.getCMFMentorDashboard().subscribe((res) => {
      const totalMentorsList = res.filter((item) =>
        item.competencyId === Number(sessionStorage.getItem('compId')) &&
        mandotoryKeys.every(key => item[key] && item[key] !== null && item[key] !== undefined)
      );
      this.totalMentorsList = this.getUniqueData(totalMentorsList);
      this.filteredMentorsList = this.totalMentorsList;
      this.mentorsList = this.totalMentorsList.slice(0, this.size);
      this.isMentorListLoading = false;
    });
  }

  getUniqueData(data) {
    const groupedData = new Map();

    for (const item of data) {
      const groupKey = `${item.competencyId}-${item.mentorEmployeeID}-${item.mentorName || ''}-${item.mentorEmail || ''}-${item.menteeName || ''}-${item.trainingsAssigned || ''}`;

      if (groupedData.has(groupKey)) {
        groupedData.get(groupKey).trainingIDs.add(item.trainingID);
      } else {
        const newItem = { ...item };
        delete newItem.trainingID;
        newItem.trainingIDs = new Set([item.trainingID]);
        groupedData.set(groupKey, newItem);
      }
    }

    const result = [];
    for (const [key, value] of groupedData.entries()) {
      const consolidatedItem = { ...value };
      consolidatedItem.listOfTrainingIds = Array.from(value.trainingIDs).join(',');
      delete consolidatedItem.trainingIDs;
      result.push(consolidatedItem);
    }
    return result;
  }

  searchMentors() {
    this.filteredMentorsList = this.totalMentorsList.filter(mentor => {
      const searchQuery = this.searchQuery.toLowerCase();

      const mentorNameMatch = mentor.mentorName && 
        mentor.mentorName.toLowerCase().includes(searchQuery);

      const mentorIdMatch = mentor.mentorEmployeeID && 
        mentor.mentorEmployeeID.toLowerCase().startsWith(searchQuery);

      const menteeNameMatch = mentor.menteeName && 
        mentor.menteeName.toLowerCase().includes(searchQuery);

      const trainingMatch = mentor.trainingsAssigned && 
        mentor.trainingsAssigned.toLowerCase().includes(searchQuery);

      return mentorNameMatch || mentorIdMatch || trainingMatch || menteeNameMatch;
    });
    
    this.from = 0;
    this.mentorsList = this.filteredMentorsList.slice(this.from, this.from + this.size);
    
    // Reset paginator to first page
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  exportTrainingData() {
    const compName = sessionStorage.getItem('compTitle');
    const exportData = this.totalMentorsList.map(mentor => ({
      "Employee ID": mentor.mentorEmployeeID,
      "Mentor": mentor.mentorName,
      "Mentor Email ID": mentor.mentorEmail,
      "Mentee Name": mentor.menteeName,
      "Total Time Spent": `${Number(mentor.totalTimeSpent).toFixed(2)} hrs`,
      "Training Assigned": mentor.trainingsAssigned,
    }));
    if (exportData.length > 0) {
      this.excelService.exportAsExcelFile(exportData, `${compName}_Mentors`);
    } else {
      this.toaster.error('No data to export');
    }

  }

  getPaginatorData(event) {
    this.size = event.pageSize;
    this.from = event.pageIndex * this.size;
    this.mentorsList = this.filteredMentorsList.slice(this.from, this.from + this.size);
  }

  updateSearchQuery(event) {
    const isFilterActive = this.filteredMentorsList.length !== this.totalMentorsList.length;
    if ((event.key === 'Backspace' || event.key === 'Delete') && this.searchQuery.length === 0) {
      if (isFilterActive) {
        this.filteredMentorsList = this.totalMentorsList;
        this.from = 0;
        this.mentorsList = this.filteredMentorsList.slice(this.from, this.from + this.size);
      }
      
      // Reset paginator to first page
      if (this.paginator && isFilterActive) {
        this.paginator.firstPage();
      }
    }
  }

  clearSearch() {
    const isFilterActive = this.filteredMentorsList.length !== this.totalMentorsList.length;
    this.searchQuery = '';
    this.filteredMentorsList = this.totalMentorsList;
    if (isFilterActive) {
      this.from = 0;
      this.mentorsList = this.filteredMentorsList.slice(this.from, this.from + this.size);
      this.paginator.firstPage();
    }
  }

}
